import React from "react";
import { HiSearch } from "react-icons/hi";
import Input from "../Input";

const SearchPanel = ({ onChange }) => {
  const handleSubmit = (e) => {
    e.preventDefault();
  };
  return (
    <form onSubmit={handleSubmit}>
      <div className="form_group">
        <Input
          type="text"
          name="search"
          onChange={onChange}
          id="search_field"
          placeholder="Search anything..."
        />
        <span>
          <HiSearch />
        </span>
      </div>
    </form>
  );
};

export default SearchPanel;
